import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Navbar.css';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Logo from '../assets/gorion.png';
import UserIcon from '../assets/user.png'; // Ícono genérico para el usuario
import API_BASE_URL from '../config';


const Navbar = () => {
  // Obtener el token desde Redux
  const token = useSelector((state) => state.auth.token);
  //console.log('Token obtenido desde Redux en Navbar:', token);

  const [user, setUser] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Decodificar el JWT y obtener la información del usuario
  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        console.error('Token no encontrado en Redux.');
        return;
      }
      try {
        const decoded = jwtDecode(token);
        console.log('Payload del token decodificado:', decoded);

        const noColaborador = decoded.id;
        console.log('noColaborador extraído del token:', noColaborador);

        const response = await axios.get(`${API_BASE_URL}api/colaboradores/${noColaborador}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data);
      } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
      }
    };

    fetchUser();
  }, [token]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Sección Izquierda: Logo */}
        <div className="navbar-left">
          <img src={Logo} alt="ORION Logo" className="navbar-logo" />
        </div>

        {/* Sección Central: Menú para desktop y mobile */}
<div className="navbar-center">
  {/* Desktop menu (visible en pantallas grandes) */}
  <div className="navbar-menu desktop-menu">
    <a href="/kiosko" className="menu-item">KIOSKO</a>
    <a href="/coordinacion" className="menu-item">COORDINACION</a>
    <a href="/handheld" className="menu-item">HANDHELD</a>
  </div>

  {/* Botón hamburguesa visible solo en móvil */}
  <button className="hamburger" onClick={toggleMenu}>
    &#9776;
  </button>

  {/* Menú móvil (solo si está abierto) */}
  {isMenuOpen && (
    <div className="navbar-menu mobile-menu">
      <a href="/kiosko" className="menu-item">KIOSKO</a>
      <a href="/operacion" className="menu-item">COORDINACION</a>
      <a href="/handheld" className="menu-item">HANDHELD</a>
    </div>
  )}
</div>



        {/* Sección Derecha: Ícono de Usuario */}
        <div className="navbar-right">
          <div className="navbar-user" onClick={toggleDropdown}>
            <img src={UserIcon} alt="User Icon" className="user-icon" />
          </div>
          {isDropdownVisible && user && (
            <div className="dropdown-user">
              <div className="dropdown-header">
                <img
                  src={`https://app.orionadministracion.com${user.fotoPerfil}`}
                  alt="User Avatar"
                  className="dropdown-avatar"
                />
                <span>{user.nombre} {user.apellidos}</span>
              </div>
              <div className="dropdown-details">
                <p><strong>Estación:</strong> {user.estacion}</p>
                <p><strong>Área:</strong> {user.area}</p>
                <p><strong>Puesto:</strong> {user.puesto}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
